import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';

import { EmptyStateImage, EmptyStateMode } from '../EmptyStateImage';

type Props = { mode?: EmptyStateMode; title?: string };

export const EmptyContentState = ({ mode = 'list', title }: Props) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap="20">
      <EmptyStateImage mode={mode} />
      <Typography variant="body2" color="text.light.secondary">
        {title}
      </Typography>
    </Box>
  );
};
